// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-calculator {
    /* max-width: 600px; */
    margin: 2rem auto;
    padding: 2rem;
    background-color: var(--clr-primary-7);
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.6s ease-in-out;
    transition: all 0.3s ease;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.plan-selection-header  {
    text-align: center;
    /* color: #1d3557; */
    font-size: 1.8rem;
    font-weight: 600;
}

.plan-selection {
    margin: 1.5rem 0;
}

.plan-options {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}

.plan-option {
    flex-basis: 30%;
    padding: 1rem;
    border: 2px solid #ccc;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s ease;
    position: relative;
}

.plan-option:hover {
    background-color: #e3f2fd;
    border-color: #0077cc;
    box-shadow: 0 5px 15px rgba(0, 87, 204, 0.2);
    transform: translateY(-3px);
}

.plan-option input {
    margin-right: 0.5rem;
}

.plan-option.selected {
    border-color: #0077cc;
    background-color: #e3f2fd;
}

.calculator-fields {
    margin: 1.5rem 0;
    display: grid;
    /* grid-template-columns: 1fr 1fr; */
    gap: 1rem;
}

.calculator-fields label {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    font-size: 1rem;
    color: var(--clr-grey-1);
}

.calculator-fields input[type="number"] {
    padding: 0.5rem;
    width: 100%;
    max-width: 80px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-left: 1rem;
    font-size: 1rem;
}

.calculator-fields input[type="checkbox"] {
    margin-right: 0.5rem;
    accent-color: #0077cc;
}

.price-display h4 {
    text-align: center;
    color: var(--clr-primary-1);
    font-size: 1.8rem;
    font-weight: 700;
    transition: all 0.3s ease;
}

.price-display.impact h4 {
    color: #ff5e57;
}

.reset-btn {
    display: block;
    margin: 1.5rem auto 0;
    padding: 0.75rem 1.5rem;
    background-color: var(--clr-grey-3);
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all 0.3s ease;
}

.reset-btn:hover {
    background-color: var(--clr-grey-1);
    box-shadow: 0 5px 15px rgba(0, 87, 204, 0.2);
    transform: translateY(-3px);
}

.tooltip {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px;
    border-radius: 5px;
    position: absolute;
    z-index: 1;
    font-size: 0.8rem;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

label:hover .tooltip {
    visibility: visible;
    opacity: 1;
}

/* Responsive Design */
@media (max-width: 768px) {
    .plan-options {
        flex-direction: column;
        gap: 1rem;
    }

    .calculator-fields {
        grid-template-columns: 1fr;
        justify-content: space-between;
    }

    .reset-btn {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/registration-multi-step-forms/PriceCalculator.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,yCAAyC;IACzC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".price-calculator {\n    /* max-width: 600px; */\n    margin: 2rem auto;\n    padding: 2rem;\n    background-color: var(--clr-primary-7);\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    animation: fadeInUp 0.6s ease-in-out;\n    transition: all 0.3s ease;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.plan-selection-header  {\n    text-align: center;\n    /* color: #1d3557; */\n    font-size: 1.8rem;\n    font-weight: 600;\n}\n\n.plan-selection {\n    margin: 1.5rem 0;\n}\n\n.plan-options {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.plan-option {\n    flex-basis: 30%;\n    padding: 1rem;\n    border: 2px solid #ccc;\n    border-radius: 10px;\n    text-align: center;\n    cursor: pointer;\n    background-color: #fff;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n.plan-option:hover {\n    background-color: #e3f2fd;\n    border-color: #0077cc;\n    box-shadow: 0 5px 15px rgba(0, 87, 204, 0.2);\n    transform: translateY(-3px);\n}\n\n.plan-option input {\n    margin-right: 0.5rem;\n}\n\n.plan-option.selected {\n    border-color: #0077cc;\n    background-color: #e3f2fd;\n}\n\n.calculator-fields {\n    margin: 1.5rem 0;\n    display: grid;\n    /* grid-template-columns: 1fr 1fr; */\n    gap: 1rem;\n}\n\n.calculator-fields label {\n    display: flex;\n    /* justify-content: space-between; */\n    align-items: center;\n    font-size: 1rem;\n    color: var(--clr-grey-1);\n}\n\n.calculator-fields input[type=\"number\"] {\n    padding: 0.5rem;\n    width: 100%;\n    max-width: 80px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    margin-left: 1rem;\n    font-size: 1rem;\n}\n\n.calculator-fields input[type=\"checkbox\"] {\n    margin-right: 0.5rem;\n    accent-color: #0077cc;\n}\n\n.price-display h4 {\n    text-align: center;\n    color: var(--clr-primary-1);\n    font-size: 1.8rem;\n    font-weight: 700;\n    transition: all 0.3s ease;\n}\n\n.price-display.impact h4 {\n    color: #ff5e57;\n}\n\n.reset-btn {\n    display: block;\n    margin: 1.5rem auto 0;\n    padding: 0.75rem 1.5rem;\n    background-color: var(--clr-grey-3);\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    font-size: 1.2rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.reset-btn:hover {\n    background-color: var(--clr-grey-1);\n    box-shadow: 0 5px 15px rgba(0, 87, 204, 0.2);\n    transform: translateY(-3px);\n}\n\n.tooltip {\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    border-radius: 5px;\n    position: absolute;\n    z-index: 1;\n    font-size: 0.8rem;\n    top: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\nlabel:hover .tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .plan-options {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .calculator-fields {\n        grid-template-columns: 1fr;\n        justify-content: space-between;\n    }\n\n    .reset-btn {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
